module.exports = {
  App: {
    wifi: 'wifi',
    name: 'Name',
    number: 'Number',
    phone: 'Phone',
    sms: 'SMS',
    email: 'E-mail',
    id: 'ID',
    done: 'Done',
    close: 'Close',
    floor: 'Floor',
    company: 'Organization',
    position: 'Position',
    remarks: 'Remarks',
    password: 'Password',
    account: 'Account',
    delete: 'Delete',
    no: 'NO',
    yes:'YES',
    bnwk: 'Can not be empty',
    nextStep: 'Next step',
    lastStep: 'Previous step',

    getVerificatioCode: 'Get verification code',
    save: 'Save',
    enter: 'Enter',

    selectTargeting: 'Select',
    jd: 'Lng',
    wd: 'Lat',
    
    view:'view',
    edit:'Edit',
    cancel:'Cancel',
    exit:'Exit',
    ok:'OK',
    signOut:'SignOut',
    pageTitle1: 'Sport Stadium',
    pageTitle2: 'Calendar',
    pageTitle3: 'Scene Setting',
    pageTitle4: 'System Setting',
    pageTitle5: 'Project Setting',
    pageTitle6: 'Gateway Setting',
    pageTitle7: 'Schedule',
    pageTitle8: 'Power Consumption',
    
    text1: 'LOGIN',
    text2: 'Tennis Games',
    text3: 'Ambient Light',
    text4: 'Football Games',
    text5: 'Player Introductions',
    text6: 'Security Lights',
    text7: 'Scence',

    text8: 'Super administrator',
    text9: 'Project Account',
    text10: 'Execute account',
    text11 : 'Please input Account and Password.',
    text12 : 'Whether to Add Scense?',
    text13 : 'Search Scense',
    text14 : 'Boot mode ended, project  setup completed',
    text15 : 'Please select project',
    text16 : 'Manage Account',
    text17 : 'whether to enter boot mode',
    text18 : 'Exit',
    login: {
      text1: 'Welcome to inhealth!',
      text2: 'Happiness and healthiness',
      text3: 'Please enter your log-in name',
      text4: 'Please enter your password',
      text5: 'Please enter the verification code',
      text6: 'SIGN IN',
      text7: 'Forgot password',
      text8: 'Remember password',
      text9: 'Chinese',
      text10: 'English',
    },
    calendar:{
      calendar_text1: 'Sun.',
      calendar_text2: 'Mon.',
      calendar_text3: 'Tues.',
      calendar_text4: 'Wed.',
      calendar_text5: 'Thur.',
      calendar_text6: 'Fri.',
      calendar_text7: 'Sat.',
      month1: 'January',
      month2: 'February',
      month3: 'March',
      month4: 'April',
      month5: 'May',
      month6: 'June',
      month7: 'July',
      month8: 'August',
      month9: 'September',
      month10: 'October',
      month11: 'November',
      month12: 'December',

      text1:'execute',
      text2:'Last year',
      text3:'Last month',
      text4:'Next month',
      text5:'Next year',
      text6:'Add Scene',
    },
    systemSetting:{
      text1:'Account Setting',
      text2:'Original Account',
      text3:'Original Password',
      text4:'Account Change',
      text5:'Password Change',
      text6:'Password Confirmation',
      text7:'Or Identity Settingiginal',
      text8:'Empty',
      text9:'Next',
      text10:'Time Zone Selected',
      text11:'East Eighth Time Zone',
      text12:'East Ten Time Zone',
      text13:'Skin Setting',
      text14:'Contacts Settings',
      text15:'Fault',
      text16:'Contact',
      text17:'E-mail',
      text18:'TEMP',
      text19:'Warranty',
      text20:'Cancel',
      text21:'OK',
      text22:'Default Avatar',
      text23:'Custom Avatar',
      text24:'Profile Change',
      text25:'Apply',
      text26:'Add Scene',
      text27:'Dimming',
      text28:'Control Area',
      text29:'schedule',
      text30:'Project Resetting',

      text31:'Reset Boot Mode',
      text32:'Reset Project Information',
      text33:'Remark:This function cannot be used without connecting to the external network',

      ldentity1:'Super Account',
      ldentity2:'Project Account',
      ldentity3:'Project Account',
      ldentity4:'Operating Account',
    },
    subAccountSetting:{
      text1:'Sub-account Setting',
      text2:'Sub-account Setting',
      text3:'Password Change',
      text4:'Password Confirmation',
      text5:'ldentity Setting',
      text6:'Sub-account List',
      text7:'Contact',
      text8:'Identity',
      text9:'Remark',
    },
    sceneSetting:{
      label1:'Scene Name',
      label2:'Control Area',
      label3:'Scene Name',
      label4:'Scene Name',
      label5:'Scene Name',

      placeholder1:'Mixed court game',

      sceneType1:'Dimming',
      sceneType2:'Marquee',
      sceneType3:'Strobe',
      sceneType3_:'Rapid Flashes',
      sceneType4:'Opening',
      sceneType5:'Goal',
      sceneType6:'Slow Flash',
      
      duration: 'Duration(s)',
      sort: 'Sort',
      list: 'List',
      type:'Type',


      btn1:'Edit',
      btn2:'Schedule',
      btn3:'Delete',
    },
    projectSettings:{
      text1: 'Project Setting',
      text2: 'Project Name',
      text3: 'Project Location',
      text4: 'Project Description',
      text5: 'Gateway Setting',
      text6: 'Device setting',
    },
    gatewayInput:{
      text1: 'No.',
      text2: 'Name',
      text3: 'ID',
      text4: 'Installaiton Date',
      text5: 'Remark',
      text6: 'wifilist',
      text7: 'wifiName',
      text8: 'wifiPwd',
      text9: 'Lamp Control List',
      text10: 'Select All',
      text11: 'Expiration date',
      text12: 'Manually add',
      text13: 'Device ID',
    },
    controllerInput:{
      text1: 'No.',
      text2: 'Name',
      text3: 'ID',
      text4: 'Gateway',
      text5: 'Group',
      text6: 'Installaiton Date',
      text7: 'Remark',
      text8: 'Normal',
      text9: 'Alarm',
      text10: 'Network',
      text11: 'Status',
    },
    groupSetting:{
      text1: 'No.',
      text2: 'Group',
      text3: 'ID',
      text4: 'Remark',
      text5: 'No light selected',
      text6: 'There are groups with unselected light',
      text7: 'Group Name',
      text8: 'Lights',
    },
    schedule:{
      text1: 'Setting Optional',
      text2: 'Specific Time',
      text3: 'Solar Time',
      text4: 'Start Time',
      text5: 'End Time',
      text6: 'Start Date',
      text7: 'End Date',
      text8: 'Days',
      text9: 'Schedule',
      text10: 'Select scene',

      label1:'Sunrise Offset Time',
      label2:'Sunset Offset Time',
      label3:'Onset from the Solar Time Selected',
      label4:'Onset from the Solar Time Selected',

      timeUnit0:'Hour',
      timeUnit1:'minute',
      
    },
    home:{
      text1:'lnformation',
      text2:'Proiec',
      text3:'Online',
      text4:'Fault',
      text5:'Outline',
      text6:'Over TEMP',
      text7:'Home',
      text8:'Scene Setting',
      text9:'Schedule Setting',
      text10:'System setting',
      text11:'Power Consumption',
      text12:'Scene',
      text13:'Group',
      text14:'All Light',
      text15:'Group',
      text16:'Brightness',
      text17:'Name',
      text18:'ID',
      text19:'Group',
      text20:'Gateway',
      text21:'Scene',
      text22:'Luminance',
      text23:'Status',
      text24:'Power',
      text25:'Current',
      text26:'Voltage',
      text27:'Online',
      text28:'Selected lights',
      text29:'Apply',
      text30:'Scene',
      

      nav_btn1:'Device setting',
      nav_btn2:'Group Setting',
      nav_btn3:'Gateway Setting', 
      
      btn_text1:'+New Project',
      

      text:'Selected lights:',

      alarmStatus0:'Normal',
      alarmStatus1:'Alarm',

      lightOnline0:'Offline',
      lightOnline1:'Online',

      text31: 'Gateway Description',
      text32: 'Networking',
      text33: 'Search',
      text34: 'ProjectId',
      text35: '	X-coordinate information',
      text36: '	Y-coordinate information',
      text37: '	Expiration time',
      text38: '	Update time',
      text39: 'TEMP(Driver)',
      text40: 'TEMP(Controller)',
    },
    
    
    placeholder: {
      text1: 'Search for username',
      text2: 'Search log description',
      text3: 'Search Name',
      text4: 'Please enter keywords to search',
    },
    sideBar: {
      text1: 'overview',
      text2: 'room',
      text3: 'LED lamp',
      text4: 'line lamp',
      text5: 'Switch panel',
      text6: 'curtain',
      text7: 'Ordinary lamp',
      text8: 'HCL lamp',
      text15: 'sensor',
      text9: 'air purifier',
      text10: 'gateway',
      text11: 'Alarm maintenance',
      text12: 'Operation Log',
      text13: 'USER',
      text14: 'Hotel Management',
      text16: 'unit',
      text17: 'Units Manager',
      text18: 'UV lamp',

      text19: 'project area',
      text20: 'Air quality testing',
      text21: 'Triliros pipeline sterilizer',
      text22: 'project management',
      text23: 'Grouping',
      text24: 'Device',
    },
    room: {
      text1: 'room',
      text2: 'map',
      text3: 'Search for room name',
      text4: 'plan',
      text5: 'Mode setting',
      text6: 'Batch binding',
      text7: 'plan',
      text8: 'Add Device',
      text9: 'Normal equipment',
      text10: 'Ordinary lamp',
      text10_: 'HCL street light',
      text11: 'sensor',
      text12: 'air purifier',
      text13: 'air quality index',
      text14: 'no data',
      text15: 'on line',
      text16: 'new-built',
      text17: 'give an alarm',
      text18: 'ID',
      text19: 'number',
      text20: 'types of',
      text21: 'state',
      text22: 'floor',
      text23: 'room',
      text24: 'copy',
      text25: 'paste',
      text26: 'delete',
      text27: 'Mode setting',
      text28: 'close',
      text29: 'floor',
      text30: 'room',
      text31: 'brightness',
      text32: 'Color temperature',
      text33: 'palette',
      text34: 'air purifier',
      text35: 'complete',
      text36: 'Floor plan',
      text37: 'Device Type',
      text38: 'Number of devices',
      text39: 'arrangement',
      text40: 'spacing',
      text41: 'COLUMN',
      text42: 'name',
      text43: 'device ID',
      text44: 'Equipment number',
      text45: 'Please upload a 1100 * 600 pixel floor plan',
      text46: 'Click to upload floor background',
      text47: 'Upload Progress',
      text48: 'current file: ',
      text49: 'Upload failed',
      text50: 'Application floor',
      text51: 'Device Mapping',
      text52: 'Download Excel file',
      text53: 'Upload Excel file',
      text54: 'Select all devices',
      text55: 'Please upload according to the format, or download the template for editing',
      text56: 'Click to upload file',
      text57: 'Error message',
      text58: 'Verification successful',
      text59: 'download',
      text60: 'save',
      text61: 'user authentication',
      text62: 'Login Name:',
      text63: 'password:',
      text64: 'confirm',

      text65: 'offline',
      text66: 'on line',

      text67: 'close',
      text67_: 'not have',
      text68: 'low',
      text69: 'centre',
      text70: 'tall',

      text71: 'side by side',
      text72: 'equidistance',
      text73: 'matrix',

      text74: 'default gateway',
      text75: 'Add other devices',
      text76: 'temperature',
      text77: 'humidity',

      text78: 'Room Settings',
      text79: 'model',
    },
    retrievePassword: {
      text1: 'forgot password',
      text2: 'user name',
      text3: 'Code',
      text4: '*For the security of your account, you will receive a secure password change link to your email. After receiving the email, you can change your password.',
      text5: 'new Password:',
      text6: 'Email verification code:',
      text7: 'sending',
    },
    mian_sidebar: {
      edition: 'version number',
      dl: 'Sign In',
      loginSuccessful: 'Login successful',
      title: 'Mains console',
      right_link: 'GIS Map',
      // sidebar_text_span1:'欢迎回来！',
      // sidebar_text_span2:'请登录您的市电系统',
      accountName: 'Username:',
      accountName1: 'Please enter user name',
      // accountName_placeholder:'请输入您的登录账号',
      forgetPassword: 'Forget Password',
      password: 'Password',
      password1: 'Please input a password',
      // password_placeholder:'请输入您的密码',
      userNav1: 'Basic Information',
      userNav2: 'change Password',
      mailbox: 'E-mail',
      verificationCode: 'Verification code',
      newPassword: 'New password',
      confirmPassword: 'Confirm password',
      cont_title: 'Create the best management experience for you',
      cont_p: 'The urban street lamp management system is a smart city management system based on the Internet of Things platform and unified management of urban street lamps from different angles such as time and space. The urban street lamp management system consists of street lights and cloud management platforms distributed in various streets. Based on the GIS map integrated with the street lamp position, the visual management platform is built. The cloud can complete the real-time monitoring of the street lights in the platform, group management, and real-time policy configuration adjustment. , complete the operation with one click. To improve work efficiency and reduce energy consumption, Yunzhisheng is willing to work with you to build a blue sky for urban development.',
      GISMap: 'GIS Map',
      GISMap_Introduction: 'The GIS map controls all your street light data on one screen, the icons are visually viewed, and the operation is in one step, so that your management work is smooth.',
      deviceManagement: 'Asset Management',
      deviceManagement_Introduction: 'Subdivide each section to quickly locate the functional location you need; loops, grouping, and strategies allowLog in you to manage street lights more intelligently.',
      alarmRepair: 'Alarm maintenance',
      alarmRepair_Introduction: 'Faulty equipment timely alarm, maintenance scheduling, fault work order multiple choices to follow up in real time, so that your daily maintenance is no longer troublesome.',
    },
    header: {
      text1: 'Log out and log in',
      text2: 'country',
      text3: 'province',
      text4: 'city',
      text5: 'hotel',
    },
    grouping: {
      text1: 'Grouped List'
    },
    message: {
      imgType: 'Uploaded pictures can only be in PNG or JPEG format!',
      text1: 'System hints',
      text2: 'Confirm',
      text3: 'Do you confirm to delete?',
      text4: 'Prompt',
      text5: 'Confim',
      text6: 'Cancel',
      text7: 'Undelete',
      text8: 'Cannot upgrade',
      text9: 'Devices not online',
      text10: ' is the latest version',
      text11: 'Please select the devices',
      text12: 'Lamp:',
      text13: ' not online',
      text14: ' not bound to gateway',
      text15: 'Device not bound to gateway',
      text16: 'Are you sure you want to delete the device? After the device is deleted, the historical data will also be deleted. Please pay attention to backup',
      text17: 'Warning',
      text18: 'Canceled',
      text19: 'HCL lights name:',
      text20: 'Sensor name:',
      text21: 'Air purifiers name:',
      text22: 'Device name:',
      text23: 'Unchecked',
      text24: 'Are you sure you want to delete the gateway?',
      text25: 'Are you sure you want to delete the Logs?',
      text26: 'Are you sure to mark and handle the current fault?',
      text27: 'Are you sure you want to delete the alarm profile?',
      text28: 'Are you sure you want to delete the repair personnel?',
      text29: 'Upload the picture only in JPG, PNG format!',
      text30: 'The size of uploaded image cannot exceed 2MB!',
      text31: 'Are you sure you want to delete the users?',
      text32: 'Are you sure you want to delete the room?',
      text33: 'Are you sure you want to delete the build?',
      text34: 'Are you sure you want to delete the floor?',
      text35: 'Are you sure you want to delete the hotel?',
      text36: 'Are you sure you want to delete the plan?',
      text37: 'Bed time should be 4 hours later than wake—up time',
      // text37:'Wake-up time should be 3 hours later than sleeping time',
      text38: 'Please wait for the previous operation to return',
      text39: 'Are you sure to cancel the fault?',
      text40: 'Are you sure you want to clear the working hours?',
      text41: 'Whether to log off',
      delDevText: 'Confirm to delete device from database?',
      text42: 'Please select the scene',
      text43: 'Confirm reset?',
      text44: 'Reset cancelled',
      text48: 'Please add items first',

      text49: 'Logged off',
      text50: 'The account is online. Confirm that the other party is logged out and continue to log in?',
      text51: 'Your account is logged in elsewhere',
    },
    powerConsumption: {
      text1: 'Last Day',
      text2: 'Last Week',
      text3: 'Last Month',
      text4: 'Last Year',
      // text5: '确定',
    },
    status: {
      text0:'System Setting',
      text1: 'Project Setting',
      text2: 'Device Setting',
      text3: 'Group Setting',
      text4: 'Scene Setting',
      text5: 'Schedule Setting',
      text6: 'Not set',
      text7: 'Already set',
    }
  }
}